import request from "@/utils/request";

export default function agentGetAccessControlInfoByQrcodeId(qrcodeId) {
  return request.post(
    `/device/common/device/getDeviceInfoByQrCodeId/${qrcodeId}`
  );
}
